import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  isFulfilledAction,
  isPendingAction,
  isRejectedAction
} from './actions';

const name = 'user';

axios.defaults.baseURL = window._env.basePath;

axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401 && error.response?.data?.key === 'dev.gate.required') {
      window.location.href = error.response.data.gate || '/api/_dev/auth';
      return new Promise(() => {}); // keskeytä ketju
    }
    return Promise.reject(error);
  }
);

export const login = createAsyncThunk(
  `${name}/login`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/auth/login/local', data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUser = createAsyncThunk(
  `${name}/getUser`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/auth/user`, {
        params: { t: new Date().getTime() }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({ ...error.response.data, notify: false });
    }
  }
);

const refreshUser = (state, action) => {
  const user = action?.payload;

  if (!user) {
    state.isLoggedIn = false;
    return;
  }

  state.isLoggedIn = true;
  state.user = user;
};

const resetUser = (state) => {
  state.errors = false;
  state.user = null;
  state.isLoggedIn = false;
};

const authSlice = createSlice({
  name,
  initialState: {
    loading: true,
    errors: false,
    user: null,
    isLoggedIn: false
  },
  reducers: {
    logout: () => {
      window.location = (window._env.basePath || '') + '/api/auth/logout';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        refreshUser(state, action);
      })
      .addCase(getUser.fulfilled, (state, action) => {
        refreshUser(state, action);
      })
      .addMatcher(isFulfilledAction(name), (state) => {
        state.loading = false;
      })
      .addMatcher(isPendingAction(name), (state) => {
        state.loading = true;
        state.errors = false;
      })
      .addMatcher(isRejectedAction(name), (state, action) => {
        resetUser(state, action);
        state.loading = false;
        state.errors = action.payload;
      });
  }
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
